"use strict";function setGPUAcceleration$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.setGPUAcceleration$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.setGPUAcceleration";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"6.0.22"},_a)),exports.setGPUAcceleration$=setGPUAcceleration$,exports.default=setGPUAcceleration$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/setGPUAcceleration.js
// module id = 1024
// module chunks = 106